import { atom } from 'recoil';
import BeaconFilterItemRequest from '../models/BeaconFilterItemRequest';

const stateFilterImgAnatomic = atom({
  key: 'filter.img.anatomic',
  default: null as BeaconFilterItemRequest | null,
});

export default stateFilterImgAnatomic;
